import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 'path-view',
    name: 'Path View',
    category: 'Education operations',
    summary: 'A connected environment for learning delivery, administration, communication, and institutional visibility.',
    audience: 'For schools, colleges, academies, and training organizations.',
    initials: 'PV',
  },
  {
    id: 'restomatic',
    name: 'Restomatic',
    category: 'Restaurant operations',
    summary: 'A restaurant ecosystem for ordering, service, kitchen workflows, reservations, and management.',
    audience: 'For independent restaurants, groups, and hospitality operators.',
    initials: 'RM',
  },
];

export default function Products() {
  useEffect(() => {
    document.title = 'Products | Nalexus Technologies';
  }, []);

  return (
    <main id="main-content" className="sync-main sync-subpage">
      <section className="sync-page-hero sync-section">
        <div className="sync-shell sync-page-hero-grid">
          <div>
            <p className="sync-eyebrow">Nalexus products</p>
            <h1>Purpose-built software for the work that matters every day.</h1>
          </div>
          <p className="sync-lead">Our products bring people, workflows, and operating information into one clear environment without mixing a product demo with a customer portal login.</p>
        </div>
      </section>

      <section className="sync-section sync-product-list-section">
        <div className="sync-shell sync-product-list">
          {products.map((product, index) => (
            <article className="sync-product-row" key={product.id}>
              <div className="sync-product-row-index">0{index + 1}</div>
              <div className="sync-product-row-visual" aria-hidden="true"><span>{product.initials}</span></div>
              <div className="sync-product-row-copy">
                <p className="sync-kicker">{product.category}</p>
                <h2>{product.name}</h2>
                <p>{product.summary}</p>
                <span>{product.audience}</span>
                <div className="sync-actions">
                  <Link className="sync-button" to={`/products/${product.id}`}>Explore {product.name}</Link>
                  <Link className="sync-text-link" to={`/contact?intent=demo&product=${product.id}`}>Request a demo <span aria-hidden="true">↗</span></Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="sync-section sync-final-cta" aria-labelledby="product-fit-heading">
        <div className="sync-shell sync-final-cta-inner">
          <p className="sync-kicker">Need something more specific?</p>
          <h2 id="product-fit-heading">A Nalexus product can be the starting point—or we can design a custom solution.</h2>
          <Link className="sync-button" to="/contact">Talk to our team</Link>
        </div>
      </section>
    </main>
  );
}
